import React from 'react';
import styles from './css/index.module.scss';

function LoadingModal({size = 60}) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.loader} style={{width: `${size}px`, height: `${size}px`}} />
    </div>
  );
}

export default LoadingModal;
